import { EGlobalFetchingServices } from '~/composables/useGlobal';

export default {
  [EGlobalFetchingServices.ticket + '9002']:
    'یکی از جریان‌های کار شامل تیکت‌های باز می‌باشد و نمی‌توان وضعیت باز و بسته بودن آن را تغییر داد ',
  [EGlobalFetchingServices.ipbx + '1000']: 'شناسه دپارتمان قبلا ساخته شده',
  [EGlobalFetchingServices.ipbx + '1001']: 'شناسه دپارتمان نامعتبر است',
  [EGlobalFetchingServices.ipbx + '3000']: 'آیتم قبلا ساخته شده',
  [EGlobalFetchingServices.ipbx + '3005']:
    'کاربری با این شماره قبلا ثبت شده است. لطفا شماره دیگری وارد کنید',
  [EGlobalFetchingServices.ipbx + '3006']:
    'کاربری با این شماره در نواتل ثبت‌نام نشده است. لطفاً ابتدا ثبت‌نام کاربر در نواتل را انجام دهید و سپس دوباره تلاش کنید',

  [EGlobalFetchingServices.sms + '1000']:
    'گیرنده ای وجود ندارد یا همه ی گیرنده ها مسدود شده اند',
  [EGlobalFetchingServices.sms + '1001']: 'موجودی کافی نیست',
  [EGlobalFetchingServices.sms + '1002']: 'شماره معتبر نیست',
  [EGlobalFetchingServices.sms + '1003']: 'فرمت فایل معتبر نیست',
  [EGlobalFetchingServices.sms + '1004']: 'گروه یا مخاطب وجود ندارد',
  [EGlobalFetchingServices.sms + '1005']:
    'تعداد درخواست های شماره مشتری بیش از مقدار تعیین شده است',
  [EGlobalFetchingServices.sms + '1006']:
    'قبلا برای این شماره درخواست ارسال شده',
  [EGlobalFetchingServices.sms + '1007']: 'قالب وجود ندارد',
  [EGlobalFetchingServices.sms + '1008']: 'اطلاعات احراز هویت معتبر نیست.',
  [EGlobalFetchingServices.sms + '1009']: 'نام کاربری یا رمز عبور صحیح نیست.',
  [EGlobalFetchingServices.sms + '1010']: 'ارتباط با سرویس‌دهنده برقرار نشد. لطفاً دوباره تلاش کنید.',
  [EGlobalFetchingServices.sms + '1011']: 'پاسخ از سرویس‌دهنده دریافت نشد.',
  [EGlobalFetchingServices.sms + '1012']: 'تعداد درخواست‌ها بیش از حد مجاز است. چند دقیقه دیگر دوباره تلاش کنید.',
  [EGlobalFetchingServices.sms + '1013']: 'سرویس پیامکی موقتاً در دسترس نیست.',
  [EGlobalFetchingServices.sms + '1409']: 'مخاطب تکراری است',

  [EGlobalFetchingServices.invoice + '8001']: 'محصول موجود نیست',
  [EGlobalFetchingServices.invoice + '8002']: 'انتخاب محصول اجباری است',
  [EGlobalFetchingServices.invoice + '8003']:
    'تعداد هر محصول انتخاب شده باید بیشتر از صفر باشد',

  'Request Timeout': 'درخواست موفقیت آمیز نبود، دوباره تلاش کنید.',
  'Bad Request': 'ساختار درخواست نامعتبر است',
  Unauthorized: 'دسترسی غیرمجاز',
  Forbidden: 'دسترسی غیرمجاز',
  'Api Not Found': 'Api یافت نشد',
};
